import {
  SpecialRequestType,
  type SpecialRequest,
} from '@ahm/api-wrappers-core';
import { generateLetterAvatar } from '@ahm/common-helpers';
import {
  Avatar,
  Button,
  Center,
  CloseButton,
  rem,
  ScrollArea,
  SimpleGrid,
  Text,
  Title,
} from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import React, { Fragment, useMemo } from 'react';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useLocaleSuffix } from '@/navigation';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export type SpecialRequestModalProps = ContextModalProps<{
  request: SpecialRequest;
  service_requests?: string | number | boolean;
  handleClickAction: (
    e: React.MouseEvent,
    id: string,
    value: any,
    param?: number
  ) => void;
}>;

const ModalSpecialRequestDetail = ({
  context,
  innerProps,
}: SpecialRequestModalProps) => {
  const { request, handleClickAction } = innerProps;
  const localeSuffix = useLocaleSuffix();
  const isMobile = useIsMobile();
  const { serviceRequests } = useBookingStore((state) => state);

  const showBtn = useMemo(() => {
    return (
      !serviceRequests ||
      (!serviceRequests[request._id] &&
        request.type !== SpecialRequestType.PerUnit)
    );
  }, [request._id, request.type, serviceRequests]);

  const handleAddSpecialRequest = (e, id, value) => {
    void handleClickAction(e, id, value);
    context.closeAll();
  };

  return (
    <Fragment>
      <CloseButton
        pos="absolute"
        iconSize={rem(24)}
        variant="transparent"
        onClick={() => {
          context.closeAll();
        }}
        c="neutral.6"
        top={rem(16)}
        style={
          isMobile
            ? {
                left: rem(16),
                outline: 'none',
              }
            : {
                right: rem(16),
                outline: 'none',
              }
        }
      />
      <Center mb={rem(24)}>
        <Avatar
          radius="md"
          variant="outline"
          size={rem(148)}
          flex="none"
          src={request.icon_url}
          alt={request[`name_${localeSuffix}`]}
          styles={{
            placeholder: {
              border: 'none',
            },
          }}
        >
          {generateLetterAvatar(request?.[`name_${localeSuffix}`])}
        </Avatar>
      </Center>
      <Title ta="center" order={3} c="neutral.7">
        {request[`name_${localeSuffix}`]}
      </Title>

      <ScrollArea.Autosize mb={rem(16)}>
        <Text
          px={{ base: rem(16), sm: rem(24) }}
          size="md"
          fw={500}
          c="neutral.6"
          ta="center"
        >
          {request[`description_${localeSuffix}`]}
        </Text>
      </ScrollArea.Autosize>

      {showBtn ? (
        <SimpleGrid w="100%" cols={1} spacing="md">
          <Button
            fullWidth
            mih={rem(48)}
            radius={rem(4)}
            fw={700}
            onClick={(e) => {
              showBtn
                ? handleAddSpecialRequest(e, request._id, true)
                : context.closeAll();
            }}
          >
            Thêm
          </Button>
        </SimpleGrid>
      ) : null}
    </Fragment>
  );
};

export default ModalSpecialRequestDetail;
